import { useRuntimeCommunity } from '../context';
import * as Styled from './Application.styled';

export const PageHeader = (props: { readonly pageBanner?: string }) => {
  const { pageBanner = '' } = props;
  const { banner: communityBanner = '', name, description = '', isNameInBanner } = useRuntimeCommunity();

  const bannerSrc = pageBanner || communityBanner;

  if (!bannerSrc) {
    return null;
  }

  return (
    <Styled.BannerWrapper>
      <img src={bannerSrc} alt="" />
      <Styled.BannerTextWrapper>
        {name && isNameInBanner && <p>{name}</p>}
        {description && <p>{description}</p>}
      </Styled.BannerTextWrapper>
    </Styled.BannerWrapper>
  );
};
